module.exports = __webpack_public_path__ + "img/DE03756.72b77cae.png";